import useRoles from "@/hooks/useRoles";

export const FileViewer = ({answer, changeImage, setImageUrl, loading, classNameImg, classNameA}) => {
  const { isChildrenOrParent } = useRoles();

  const isImg = (str) => (str.includes('.jpeg') || str.includes('.png') || str.includes('.jpg') || str.includes('.webp') || str.includes('.svg'));
  const imgSrc = process.env.REACT_APP_PATH_FILE + '/' + answer;
  if(answer) {
    if(isImg(answer) && !isChildrenOrParent) {
      return (
        <img 
          onClick={() => {
            if(changeImage){
              if(loading){
                return;
              }
              setImageUrl(imgSrc)
            }
            else{
              window.open(imgSrc, '_blank');
            }
          }}
          className={classNameImg} 
          src={imgSrc} />
      )
    }
    else{
      return <a href={imgSrc} className={classNameA} target='_blank' rel="noreferrer">Открыть файл</a>;
    }
  }
  else{
    return 'Учащийся не прикрепил файл';
  }
}